import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default () => {
  const presenter = useLocalStore(() => ({
    get donationUrl() {
      const channel = Entities.GroupsStore.activeGroup;

      return channel.donationUrl;
    },
  }));

  return presenter;
};
